import { render, staticRenderFns } from "./contract-audit.vue?vue&type=template&id=55222679&scoped=true"
import script from "./contract-audit.vue?vue&type=script&lang=js"
export * from "./contract-audit.vue?vue&type=script&lang=js"
import style0 from "./contract-audit.vue?vue&type=style&index=0&id=55222679&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55222679",
  null
  
)

export default component.exports